function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "portfolio",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.6,17.3 L19.5,19.5 L17.3,15.6 L15.9,15.9 L15.6,17.3 Z M10.6,8.9 L6.8,6.8 L8.9,10.6 L10.3,10.3 L10.6,8.9 Z M17.3,10.6 L19.5,6.8 L15.6,8.9 L15.9,10.3 L17.3,10.6 Z M8.9,15.6 L6.8,19.5 L10.6,17.3 L10.3,15.9 L8.9,15.6 Z M15.1,11.1 L13.1,3.1 L11.1,11.1 L3.1,13.1 L11.1,15.1 L13.1,23.1 L15.1,15.1 L23.1,13.1 L15.1,11.1 Z M14.6,13.1 C14.6,13.9 13.9,14.6 13.1,14.6 C12.3,14.6 11.6,13.9 11.6,13.1 C11.6,12.3 12.3,11.6 13.1,11.6 C13.9,11.6 14.6,12.3 14.6,13.1 Z M13.1,26.2 C5.9,26.2 0,20.4 0,13.1 C0,5.8 5.9,2.84217094e-14 13.1,2.84217094e-14 C20.3,2.84217094e-14 26.2,5.9 26.2,13.1 C26.2,20.3 20.4,26.2 13.1,26.2 Z M13.1,1.5 C6.7,1.5 1.5,6.7 1.5,13.1 C1.5,19.5 6.7,24.7 13.1,24.7 C19.5,24.7 24.7,19.5 24.7,13.1 C24.7,6.7 19.5,1.5 13.1,1.5 Z",
  id: "Shape"
})));

function SvgPortfolio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Portfolio") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.a6f0ca9e.svg";
export { ForwardRef as ReactComponent };